/**
 * 移除dom元素，兼容IE浏览器
 */
export const removeDom = (dom: Element) => {
    if (dom) {
        if (dom.remove) {
            dom.remove();
        } else {
            // IE浏览器
            if (dom.parentNode) {
                dom.parentNode.removeChild(dom);
            }
        }
    }
};
